module.exports = __webpack_public_path__ + "ac4513a5562ba802bb34a74473f68deb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/news2.jpg
 ** module id = 516
 ** module chunks = 1
 **/